import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setTitle } from 'redux/slices/uiSlice';
import CarrierForm from 'components/admin/CarrierForm';
import { updateCarrier } from 'services/admin/providerService';

function EditCarrierScreen() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { currentCarrier } = useSelector(store => store.providers);

    useEffect(() => {
        dispatch(setTitle('Editar Carrier'));
        // eslint-di
    }, [])

    return (
        <CarrierForm
            title={"Cancelar"}
            defaultValues={{
                name: currentCarrier.name,
                operadora: currentCarrier.operadora,
                carrier_id: currentCarrier.carrier_id,
            }}
            goBack={() => {
                navigate(-1);
            }}
            submit={(data) => {
                updateCarrier(currentCarrier.id, data).then((result) => {
                    navigate(-1);
                }).catch((e) => {
                    console.log(e);
                });
            }}
        />
    );
}

export default EditCarrierScreen;